export const content = {
  format: 'Format',
  buchungsnummer: 'Buchungsnummer',
  praesenzPendant: 'Präsenz-Pendant',
  onlinePendant: 'Online-Pendant',
} as const;
